import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGeneralStop = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.8333 7C12.8333 10.2217 10.2217 12.8333 7 12.8333C3.77834 12.8333 1.16667 10.2217 1.16667 7C1.16667 3.77834 3.77834 1.16667 7 1.16667C10.2217 1.16667 12.8333 3.77834 12.8333 7ZM9.86163 10.6866C9.07139 11.3009 8.07842 11.6667 7 11.6667C4.42267 11.6667 2.33333 9.57733 2.33333 7C2.33333 5.92158 2.69913 4.92861 3.31342 4.13837L9.86163 10.6866ZM10.6866 9.86163L4.13837 3.31342C4.92861 2.69913 5.92158 2.33333 7 2.33333C9.57733 2.33333 11.6667 4.42267 11.6667 7C11.6667 8.07842 11.3009 9.07139 10.6866 9.86163Z",
		fill: "black",
		fillOpacity: .6
	})
});
export default SvgGeneralStop;
